import { createContext } from 'react';

const SharedContext = createContext({});

export const SharedProvider = SharedContext.Provider;

export default SharedContext;
